export default __webpack_public_path__ + "static/media/btn-zeroback-start-at_de@3x.7ee7b6d8.png";